import React from 'react'
import PropTypes from 'prop-types'
import './index.css'

export class ForgottenPassword extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick () {
    this.setState(prevState => ({
      open: !prevState.open
    }))
  }

  render () {
    let cls1, cls2
    if (this.state.open) {
      cls1 = 'fgp-he fgp-he-on'
      cls2 = 'fgp-b fgp-b-on'
    } else {
      cls1 = 'fgp-he'
      cls2 = 'fgp-b'
    }
    return (
      <div className='fgp-con'>
        <div className={cls1} onClick={this.handleClick} >Zapomenuté heslo</div>
        <button className={cls2} onClick={this.props.onReset}>Obnovit</button>
      </div>
    )
  }
}

ForgottenPassword.propTypes = {
  onReset: PropTypes.func
}

export default ForgottenPassword



// WEBPACK FOOTER //
// ./src/components/UserForms/ForgottenPassword.js